export const productionLines = (state = {
    loader: {
        actions: []
    }
}, action) => {
    const { loader } = state;
    const { actions } = loader;

    switch (action.type) {
        case "CREATE_PRODUCTION_LINE":
        case "UPDATE_PRODUCTION_LINE":
        case "DELETE_PRODUCTION_LINE":
            return {
                ...state,
                loader: {
                    ...loader,
                    actions: [...actions, action.type]
                }
            };
        case "CREATE_PRODUCTION_LINE_SUCCESS":
        case "UPDATE_PRODUCTION_LINE_SUCCESS":
        case "DELETE_PRODUCTION_LINE_SUCCESS":
            return {
                ...state,
                loader: {
                    ...loader,
                    actions: actions.filter(a => a.type === action.type.substring(0, action.type.length - 8))
                }
            };

        default:
            return { ...state };
    }
}
